<template>
  <svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20 10.9717H10.3885L14.1922 0L0 15.1668H9.28425L5.80777 25.9772L20 10.9717Z" fill="currentcolor" />
  </svg>
</template>
